import { AppointmentStatus } from './enums/AppointmentStatus.enum';
import { FullAuditedAggregateRoot } from '@models/shared/FullAuditedAggregateRoot';
import {IAppointmentFormData} from '@models/data/appointments/interfaces/IAppointmentFormData';
import {DateUtil} from '@shared/utils/dates/DateParsing.util';
import {hasValue} from '@shared/utils/helpers';

export class Appointment extends FullAuditedAggregateRoot {
  startTime: string;
  endTime: string;
  recordedStartTime: string;
  recordedEndTime: string;
  status: AppointmentStatus;
  patientFitMedProfileId: string;
  practitionerFitMedProfileId: string;
  appointmentTypeId: string;
  appointmentRequestId?: string;
}

export class AppointmentUtil {
  /**
   * Returns a boolean indicating whether a given appointment is in progress based on if it has a recorded
   * start time but no recorded end time
   * @param appointment
   */
  static isAppointmentInProgress(appointment: Appointment): boolean {
    return hasValue(appointment.recordedStartTime) && !hasValue(appointment.recordedEndTime)
  }

  static toFormData(
    appointmentUpdating: Appointment = null,
    startTime: Date | string = null,
    endTime: Date | string = null,
    status: AppointmentStatus = null,
    appointmentTypeId: string = null,
    appointmentRequestId: string = null,
    patientFitMedProfileId: string = null,
  ): IAppointmentFormData {
    const localisedStartTimeBefore = DateUtil.toLocalTimeString(appointmentUpdating?.startTime);
    const localisedStartTimeAfter = DateUtil.toLocalTimeString(endTime);

    return {
      startTime: hasValue(startTime) ? DateUtil.toUTC(startTime) : appointmentUpdating?.startTime,
      endTime: hasValue(endTime) ? DateUtil.toUTC(endTime) : appointmentUpdating?.endTime,
      localisedStartTimeBefore,
      localisedStartTimeAfter,
      status: hasValue(status) ? status : appointmentUpdating?.status,
      appointmentTypeId: hasValue(appointmentTypeId) ? appointmentTypeId : appointmentUpdating?.appointmentTypeId,
      appointmentRequestId: hasValue(appointmentRequestId) ? appointmentRequestId : appointmentUpdating?.appointmentRequestId,
      patientFitMedProfileId: hasValue(patientFitMedProfileId) ? patientFitMedProfileId : appointmentUpdating?.patientFitMedProfileId,
    };
  }
}
